// extracted by mini-css-extract-plugin
export default {"pageContent":"Main_pageContent__0g3bU","infoText":"Main_infoText__0D5Bu","infoLink":"Main_infoLink__ZRB6H"};